export default "__VITE_ASSET__TXPfImFa__"